// Enums.js

export const EngagementType = {
    NODE_FAVORITE: 'NODE_FAVORITE',
    NODE_COMMENT: 'NODE_COMMENT',
    NODE_LIKE: 'NODE_LIKE',
    NODE_SHARE: 'NODE_SHARE',
    COMMENT_LIKE: 'COMMENT_LIKE',
    COMMENT_DISLIKE: 'COMMENT_DISLIKE',
    ACTIVITY_REACTION: 'ACTIVITY_REACTION',
    COMMENT_REPLY: 'COMMENT_REPLY',
    CONTRIBUTION_MADE: 'CONTRIBUTION_MADE',
    CONTRIBUTION_VIEW: 'CONTRIBUTION_VIEW',
    SESSION_SET: 'SESSION_SET',
    SESSION_CANCELLED: 'SESSION_CANCELLED',
    USER_VIEW: 'USER_VIEW',
};

export const NotificationType = {
    // Engagement-based notifications
    ENGAGEMENT_LIKE: 'ENGAGEMENT_LIKE',
    ENGAGEMENT_COMMENT: 'ENGAGEMENT_COMMENT',
    ENGAGEMENT_FAVORITE: 'ENGAGEMENT_FAVORITE',
    ENGAGEMENT_SHARE: 'ENGAGEMENT_SHARE',
    ENGAGEMENT_CONTRIBUTION: 'ENGAGEMENT_CONTRIBUTION',
    ENGAGEMENT_SESSION: 'ENGAGEMENT_SESSION',
    ENGAGEMENT_USER_VIEW: 'ENGAGEMENT_USER_VIEW',

    // System notifications
    SYSTEM_WELCOME: 'SYSTEM_WELCOME',
    SYSTEM_MAINTENANCE: 'SYSTEM_MAINTENANCE',
    SYSTEM_UPDATE: 'SYSTEM_UPDATE',

    // Admin notifications
    ADMIN_ANNOUNCEMENT: 'ADMIN_ANNOUNCEMENT',
    ADMIN_WARNING: 'ADMIN_WARNING',
    BASE_LIMIT_THRESHOLD: 'BASE_LIMIT_THRESHOLD',

    // Business notifications
    BUSINESS_PROMOTION: 'BUSINESS_PROMOTION',
    BUSINESS_REMINDER: 'BUSINESS_REMINDER',

    // Channel notifications
    CHANNEL_MESSAGE: 'CHANNEL_MESSAGE',
    CONVERSATION_MESSAGE: 'CONVERSATION_MESSAGE',
    THREAD_REPLY: 'THREAD_REPLY',

    // Node notifications
    NODE_CHANGE: 'NODE_CHANGE',
    PO_VENDOR_SIGNED: 'PO_VENDOR_SIGNED',
};

export const NotificationPriority = {
    HIGH: 'HIGH',
    NORMAL: 'NORMAL',
    LOW: 'LOW',
};

export const NotificationSourceType = {
    ENGAGEMENT: 'ENGAGEMENT',
    SYSTEM: 'SYSTEM',
    ADMIN: 'ADMIN',
    BUSINESS: 'BUSINESS',
    CHANNEL: 'CHANNEL',
    NODE_CHANGE: 'NODE_CHANGE',
};

/**
 * Shared photo shapes.
 */
export const PhotoShape = {
    CIRCLE: 'CIRCLE',
    SQUARE: 'SQUARE',
};

/**
 * Feed view types for the home section.
 */
export const HomeView = {
    FORYOU: "FORYOU",
    FOLLOWING: "FOLLOWING",
    CALENDAR: "CALENDAR",
    DISCOVER: "DISCOVER",
}

/**
 * Defines the save modes for the NodeWizard.
 */
export const SaveMode = {
    ADD: "ADD",
    UPDATE: "UPDATE"
}

/**
 * Defines the tab types in a desktop node.
 */
export const NodeTabType = {
    ABOUT: "ABOUT",
    COMMENTS: "COMMENTS"
}

export const StreamViewType = {
    HOST: "HOST",
    VIEWER: "VIEWER"
}

export const PlanType = {
    FREE: "FREE",
    PRO: "PRO",
    PRO_PLUS: "PRO_PLUS",
    CREATOR: "CREATOR",
    CREATOR_PLUS: "CREATOR_PLUS",
    ENTERPRISE: "ENTERPRISE",
}

export const PinType = {
    HOME: "HOME",
    EXPLORE: "EXPLORE"
}

export const UserSettingType = {
    NAME: 'NAME',
    BIO: 'BIO',
};

export const ItemSize = {
    SMALL: 'SMALL',
    LARGE: 'LARGE',
    THUMB: 'THUMB',
};

export const SectionType = {
    FAVORITES: 'FAVORITES',
    CALENDAR: 'CALENDAR',
    SCHEDULE: 'SCHEDULE',
    CHANNELS: 'CHANNELS',
    CONVERSATIONS: 'CONVERSATIONS',
    NODE: 'NODE',
    HOME: 'HOME',
    INBOX: 'INBOX',
    LIBRARY: 'LIBRARY',
    LOCATIONS: 'LOCATIONS',
    MUSIC: 'MUSIC',
    NOTIFICATIONS: 'NOTIFICATIONS',
    ORDERS: 'ORDERS',
    TRASH: 'TRASH',
    USER: 'USER',
    SEARCH: 'SEARCH',
    SOURCE: 'SOURCE',
    WATCH: 'WATCH',
    SETTINGS: 'SETTINGS',
    STUDIO: 'STUDIO',
    API: 'API',
};

export const ThemeMode = {
    DARK: 'DARK',
    LIGHT: 'LIGHT',
};

export const LoginMode = {
    LOGIN: 'LOGIN',
    SIGNUP: 'SIGNUP'
};

export const NodeMode = {
    ADD: 'ADD',
    EDIT: 'EDIT',
};